import { Password, Validation } from '@ps/web-shared-components';
import {
  checkUserPassword,
  getValidatorsForLicense,
  lengthRange,
  mustContainNumber,
  mustNotContain,
  mustStartWithLetter,
  required
} from '@ps/web-shared-validators';
import React from 'react';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import PasswordStrength from '../PaswordStrength/PasswordStrength';

import {
  TXTCLI_Confirm_Password,
  TXTCLI_New_Password,
  TXTCLI_Password_is_not_confirmed,
  TXTMOB_Current_Password,
  TXTWCL_Must_be_between_N0_and_N1_char_ELL,
  TXTWCL_Must_contain_at_least_one_digi_ELL,
  TXTWCL_Must_not_contain_your_Stars_ID,
  TXTWCL_Must_start_with_a_letter_XA_ZX_ELL,
  TXTWCL_Please_enter_your_PasswordX
} from './ChangePasswordInputs.messages.json';
import styles from './ChangePasswordInputs.scss';

interface Props {
  hideOldPasswordField?: boolean;
}
const ChangePasswordInputs: React.FC<Props> = ({ hideOldPasswordField }) => {
  const site = useSelector(select.cms.getSiteId);
  const account = useSelector(select.account.get);
  const isRealMoneyOK = useSelector(select.account.isRealMoneyOK);
  const disableFormUS = useSelector(select.account.disableFormUS);

  return (
    <>
      {!hideOldPasswordField && (
        <Password
          autoComplete="current-password"
          id="oldPassword"
          disabled={disableFormUS}
          label={TXTMOB_Current_Password}
          validators={[required(TXTWCL_Please_enter_your_PasswordX)]}
        />
      )}
      <Field name="newPassword">
        {({ input: { value } }) => (
          <Password
            autoComplete="new-password"
            id="newPassword"
            label={TXTCLI_New_Password}
            disabled={disableFormUS}
            validationVariant={Validation.List}
            validators={[
              lengthRange(8, 20, {
                ...TXTWCL_Must_be_between_N0_and_N1_char_ELL,
                values: { 0: '8', 1: '20' }
              }),
              mustNotContain(account.userId, TXTWCL_Must_not_contain_your_Stars_ID),
              mustStartWithLetter(TXTWCL_Must_start_with_a_letter_XA_ZX_ELL),
              mustContainNumber(TXTWCL_Must_contain_at_least_one_digi_ELL),
              ...getValidatorsForLicense(site, 'password', { account, isRealMoneyOK }),
              checkUserPassword
            ]}
          >
            {value && <PasswordStrength className={styles.strength} password={value} />}
          </Password>
        )}
      </Field>
      <Password
        autoComplete="new-password"
        id="confirmNewPassword"
        label={TXTCLI_Confirm_Password}
        disabled={disableFormUS}
        validators={[required(TXTCLI_Password_is_not_confirmed)]}
      />
    </>
  );
};

export default ChangePasswordInputs;
